export default __webpack_public_path__ + "static/media/C_06_01_bg.183c108b.mp4";